class DecorateHelper {
    static highLightControlTitle (title, highlightText, backgroundColor, textColor) {
        let highLightedTitle = title;
        let substring = highlightText.toLowerCase();
        let controlTitle = highLightedTitle.toLowerCase();

        let index = controlTitle.indexOf(substring);
        let localTitle = highLightedTitle;
        highLightedTitle = '';

        for (let i = 0; i < index; i++) {
            highLightedTitle += localTitle[i];
        }
        highLightedTitle += "<span style='background: " + backgroundColor +
            "; color: " + textColor + "; '>";
        for (let i = index; i < index + substring.length; i++) {
            highLightedTitle += localTitle[i];
        }
        highLightedTitle += "</span>";
        for (let i = index + substring.length; i < controlTitle.length; i++) {
            highLightedTitle += localTitle[i];
        }

        return highLightedTitle;
    }

    static boldControlTitle (title) {
        return "<span style='font-weight:bold'>" + title + "</span>";
    }
}

export default DecorateHelper;